import { Box, Chip, FormControl, InputLabel, Modal, OutlinedInput, TextField } from '@mui/material';
import TopBar from '../Layout/TopBar';
import MyButton from '../Layout/MyButton';
import { faCheck, faTimes, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { DateTimePicker } from '@mui/x-date-pickers';
import React from 'react';
import MySelect from '../Layout/MySelect';

const UnavailablePeriodModal = (props) => {
  const {
    openModal,
    css,
    demandePassageStyle,
    loading,
    listCenters,
    unavailablePeriod,
    setUnavailablePeriod,
    handleValidUnavailablePeriod,
    deleteUnavailablePeriod,
    handleCloseModal,
    profil
  } = props;

  return (
    <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
      <div className='modal'>
        <div style={css.modalUnavailablePeriod}>
          <TopBar title="Déclaration d'indisponibilité" className='topbar-contenu' color='#bb0060c4' titleWidth={'100%'}
                  buttons={
                    <div className='topbar-buttons'>
                      <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} sx={{backgroundColor: '#7f2352c2 !important'}} />
                    </div>
                  }
          />
          <div style={{
            ...css.containerUnavailablePeriod,
            padding: '0 30px'
          }}>
            {
              loading &&
              <div className='row' style={css.fullRow}>
                <ClipLoader color='#0094ca' loading={loading} size={75}
                            css={'display: flex; margin: 25px;justify-content: center;'} />
              </div>
            }
            {
              !loading && <>
                <div style={{
                  width: '95%',
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                }}>
                  <FormControl>
                    <FormLabel>Sélectionner le/les centre(s) concerné(s) (*)</FormLabel>
                      <MySelect
                        labelClass={'select-label-black'}
                        name={'center'}
                        label={'Centre(s)'}
                        multiple={true}
                        displayLabel={true}
                        datas={listCenters}
                        disableClass={true}
                        value={unavailablePeriod.centers}
                        handleChange={(e) => setUnavailablePeriod({ ...unavailablePeriod, centers: e.target.value })}
                      />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Choisissez une date de début</FormLabel>
                    <DateTimePicker
                      label='Date début'
                      name='startDate'
                      value={unavailablePeriod.start}
                      style={{ ...demandePassageStyle.textField, width: '30%' }}
                      onChange={(newValue) => setUnavailablePeriod({ ...unavailablePeriod, start: newValue })}
                      renderInput={(params) => <TextField {...params} />}
                      inputVariant='outlined'
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Choisissez une date de fin</FormLabel>
                    <DateTimePicker
                      label='Date fin'
                      name='endDate'
                      value={unavailablePeriod.end}
                      style={{ ...demandePassageStyle.textField, width: '30%' }}
                      onChange={(newValue) => setUnavailablePeriod({ ...unavailablePeriod, end: newValue })}
                      renderInput={(params) => <TextField {...params} />}
                      inputVariant='outlined'
                    />
                  </FormControl>
                  <FormControl >
                    <FormLabel>Champ libre</FormLabel>
                    <TextField
                      label='Champ libre'
                      name='comment'
                      value={unavailablePeriod.comment}
                      style={{ ...demandePassageStyle.textField, width: '100%' }}
                      onChange={(e) => setUnavailablePeriod({ ...unavailablePeriod, comment: e.target.value })}
                      variant='outlined'
                    />
                  </FormControl>
                </div>
                <div style={css.rowValidation}>
                  <MyButton onClick={() => handleValidUnavailablePeriod()} style={'buttonValidation'}
                            label={'Valider la période'} icon={faCheck} />
                  {(profil.profil === 1 || profil.profil === 2) &&
                  <MyButton onClick={() => deleteUnavailablePeriod()} style={'buttonRejected'}
                            label={'Supprimer la période'} icon={faTimes} />
                  }
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default UnavailablePeriodModal